import { apiClient } from "./apiClient";

export type FilaPorcaoAdicional = {
  nome: string;
  quantidade?: number;
};

export type FilaPorcaoDescricao = {
  name: string;
  adicionais: string[];
  numero_pedido: number;
  foodfly_pedido_id: string;
  observacao: string | null;
  quantidade: number;
  item_original_name: string;
};

export type FilaPorcaoItem = {
  id: number;
  pedidoFoodflyId: number;
  numeroPedido: number;
  foodflyPedidoId: string;
  produtoNome: string;
  produtoIdFoodfly?: string | null;
  adicionais: FilaPorcaoAdicional[];
  descricao: FilaPorcaoDescricao[];
  observacao?: string | null;
  valorTotal?: string | number | null;
  status: string;
  assignedToUserId?: number | null;
  startedAt?: string | null;
  finishedAt?: string | null;
  tempoTotal?: number | null;
  lojaId: number;
  createdAt: string;
  updatedAt: string;
  pedidoFoodfly?: {
    id: number;
    identificador: string | null;
    mesaId?: string | null;
    comandaId?: string | null;
    telefone: string | null;
    isEntrega: boolean;
    observacao: string | null;
    statusIntegracao: string;
    numeroPedido: number;
  };
  assignedToUser?: { id: number; nome: string } | null;
};

export type FilaPorcoesListResponse = {
  data: FilaPorcaoItem[];
  page: number;
  limit: number;
  total: number;
  totalPages: number;
};

export type FilaPorcoesEstatisticas = {
  lojaId: number;
  pending: number;
  inProgress: number;
  done: number;
  cancelled: number;
  total: number;
};

export const filaPorcoesService = {
  async list(params?: {
    status?: string;
    numeroPedido?: string;
    data?: string;
    page?: number;
    limit?: number;
  }): Promise<FilaPorcoesListResponse> {
    const search = new URLSearchParams();
    if (params?.status) search.set("status", params.status);
    if (params?.numeroPedido) search.set("numeroPedido", params.numeroPedido);
    if (params?.data) search.set("data", params.data);
    if (params?.page) search.set("page", String(params.page));
    if (params?.limit) search.set("limit", String(params.limit));
    const qs = search.toString();
    return apiClient.get<FilaPorcoesListResponse>(
      `/fila-porcoes${qs ? `?${qs}` : ""}`
    );
  },

  async estatisticas(data?: string): Promise<FilaPorcoesEstatisticas> {
    const qs = data ? `?data=${encodeURIComponent(data)}` : "";
    return apiClient.get<FilaPorcoesEstatisticas>(
      `/fila-porcoes/estatisticas${qs}`
    );
  },

  async iniciar(id: number) {
    return apiClient.post(`/fila-porcoes/${id}/iniciar`, {});
  },

  async finalizar(id: number) {
    return apiClient.post(`/fila-porcoes/${id}/finalizar`, {});
  },

  async reprocessarEvento(webhookEventId: number) {
    return apiClient.post(
      `/fila-porcoes/reprocessar-evento/${webhookEventId}`,
      {}
    );
  },
};
